/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import '../node_modules/bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import './lib/slick.min';
import './lib/jquery.hoverIntent.min';
import SlickSlider from './components/slick';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';


import './components/block-cart';
import lazysizes from 'lazysizes'


// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
    prestashop[i] = EventEmitter.prototype[i];
}
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}
window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        // This event is triggered when the page is shown from the back/forward cache
        window.scrollTo(0, 0); // Scroll to the top
    }
});
$(document).ready(() => {
    const form = new Form();
    let slickSlider = new SlickSlider();
    let topMenuEl = $('#_desktop_top_menu #top-menu');
    let topMenu = new TopMenu(topMenuEl);

    form.init();
    slickSlider.init();
    topMenu.init();

    //display input file content in custom file input BS
    $('.custom-file-input').on('change', function () {
        let fileName = $(this).val().split('\\').pop();
        $(this).next('.custom-file-label').addClass("selected").html(fileName);
    })
    if ($("#back-to-top").length > 0) {
        let backToTop = $("#back-to-top");

        function setMainPadding() {
            var headerHeight = $("#header").outerHeight(); // Get the height of the header
            $("#wrapper").css("padding-top", headerHeight + "px"); // Set padding-top of #main
            $(".displayCustomBanners5").css("padding-top", headerHeight + "px"); // Set padding-top of #main homepage
        }

        window.onscroll = function () { scrollFunction() };
        function scrollFunction() {
            //Back To TOP && fixed MENU
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                backToTop.show();

                $('#header').addClass('fixed-header');
                setMainPadding();

            } else {
                backToTop.hide();

                $('#header').removeClass('fixed-header');
                $("#wrapper").css("padding-top", "0px");
                $(".displayCustomBanners5").css("padding-top", "0px");
            }
        }

        $('#back-to-top').on('click', function () {
            $('html, body').animate({ scrollTop: 0 }, 800);
        })
    }

    $('.ybc-menu-toggle, .ybc-menu-vertical-button').on('click', function () {
        if ($(this).hasClass('closed')) {
            $('.menu-burger').hide();
            $('.menu-close').show();
        }
        if ($(this).hasClass('opened')) {
            $('.menu-burger').show();
            $('.menu-close').hide();
        }
    });

    // hide specific html on desktop
    if ($(window).width() > 992) {
        // Screen is larger than 992px
        $('.hide-desktop').remove();
    } else {
        // Screen is 992px or smaller
        $('.hide-mobile').remove();
    }


    // Clear cart button
    $('#empty-cart-button').on('click', function () {
        $('.remove-from-cart').each(function () {
            $(this).click();  // Simulate click on each remove product button
        });
    });


});

document.addEventListener('lazyloaded', function (e) {
    $(e.target).parent().addClass('rc--lazyload');
});

$(document).ready(function () {
    $(".js-open-callback-popup").on("click", function () {
        $('#bloc_informatif').hide();
    });
});

$(document).ready(function () {
    const slider = document.querySelector('.scrollable');
    if (slider) {
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
            console.log(walk);
        });
    }

});
$(document).ready(function () {
    $(document).on('click', '.remove-from-cart', function (e) {
        e.preventDefault();

        var href = $(this).attr('href');

        $.ajax({
            url: href,
            type: 'GET',
            dataType: 'html',
            success: function (response) {
                prestashop.emit('updateCart', {
                    reason: 'update',  // Provide a reason for the update if needed
                    resp: response  // Response data, if applicable
                });
            },
            error: function (xhr, status, error) {
                console.error('AJAX error:', error);
            }
        });
    });

    $(document).on('mouseenter', '.hover-cart', function () {
        $('.custom-ajax-cart').css('display', 'block');
    });

    $(document).on('mouseleave', '.hover-cart', function () {
        $('.custom-ajax-cart').css('display', 'none');
    });

    $(document).on('click', '.visible--desktop .see-more-product-info', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('.visible--desktop .tab-data').offset().top - 150
        }, 1000);
        $('.desc-item').toggleClass('active-tab');
        $('.desc-item').find('.hidden-content').slideToggle();
    });

    $(document).on('click', '.see-more-product-accessories', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('.featured-products').offset().top - 150
        }, 1000);
    });

    $(document).on('click', '.visible--desktop .var-choice', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('not-available-product')) {
            $('.group_' + $(this).data('group') + ' .var-choice').removeClass('active');
            $(this).addClass('active');
            $('.choice-variant-' + $(this).data('group') + '-' + $(this).data('option')).click();
        }

    });

    $(document).on('click', '.visible--mobile .var-choice', function (e) {
        if (!$(this).hasClass('not-available-product')) {
            e.preventDefault();
            $('.group_' + $(this).data('group') + ' .var-choice').removeClass('active');
            $(this).addClass('active');
            $('.choice-variant-' + $(this).data('group') + '-' + $(this).data('option')).click();
        }

    });

    $(document).on('click', '.visible--mobile .see-more-product-info', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".visible--mobile .tab-data").offset().top - 150
        }, 1000);
    });
    $(".increase-qty").on("click", function () {
        $('#quantity_wanted_new').val(+$('#quantity_wanted_new').val() + 1);
    });
    $(".footer-add-to-cart button").on("click", function () {
        $('.visible--mobile .product-actions .add-to-cart ').click();
    });
    $(".decrease-qty").on("click", function () {
        if (+$('#quantity_wanted_new').val() > 1) {
            $('#quantity_wanted_new').val(+$('#quantity_wanted_new').val() - 1);
        }
    });

    // CATEGORY PART
    $(document).on('click', '.show-search-mobile', function () {
        $('.PM_ASBlockOutput').show();
    });
    $(document).on('click', '.visible--mobile .card-header', function (e) {
        $('.PM_ASBlockOutput').hide();
    });

    $('.category-more-data').on('click', function () {
        let tvCategoryMainDiv = $('.tv-category-main-div');
        tvCategoryMainDiv.toggleClass('fullHeight');
        if (tvCategoryMainDiv.hasClass('fullHeight')) {
            $(this).find('span').text('Voir moins');
            $(this).addClass('open-toggle');
        }
        else {
            $(this).find('span').text('Voir plus');
            $(this).removeClass('open-toggle');
        }
    })

    $(document).on('click', '.PM_ASCriterionsGroupList .PM_ASCriterionsGroupTitle', function (e) {
        $(this).parent().find('.PM_ASCriterionsGroupOuter').toggle();
    });


    if ($('.category-more-data').length > 0) {

        //alert('found')
    }
    $('.card--reassurance .slick-slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        adaptiveHeight: true,
        prevArrow: false,
        nextArrow: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    arrows: false

                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    arrows: false
                }
            }

        ]
    });

    $('.videos-block .slick-slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: false,
        nextArrow: false,
        responsive: [
            {
                breakpoint: 9999,
                settings: 'unslick',
                prevArrow: false,
                nextArrow: false,
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    variableWidth: true,
                    prevArrow: "<button type='button' class='slick-prev pull-left'><i class=\"material-icons\">keyboard_arrow_left</i></button>",
                    nextArrow: "<button type='button' class='slick-next pull-right'><i class=\"material-icons\">keyboard_arrow_right</i></button>",
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    prevArrow: "<button type='button' class='slick-prev pull-left'><i class=\"material-icons\">keyboard_arrow_left</i></button>",
                    nextArrow: "<button type='button' class='slick-next pull-right'><i class=\"material-icons\">keyboard_arrow_right</i></button>",
                    dots: false,
                    infinite: true,

                }
            }
        ]


    });
    $('.product-slider .slick-slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1.5,
        adaptiveHeight: true,
        prevArrow: false,
        nextArrow: false,


    });

    $(".tab-title").on("click", function () {
        $(this).parent('.tab-item').toggleClass('active-tab');
        if ($(this).parent('.tab-item').hasClass('has-slider')) {
            let hiddenContent = $(this).find('.hidden-content');
            hiddenContent.css('opacity', 0);
            hiddenContent.slideToggle(function () {
                $(this).parent('.tab-item').find('.slick-slider').slick('refresh');
                hiddenContent.css('opacity', "1");
            });
        }
        else {
            $(this).parent('.tab-item').find('.hidden-content').slideToggle();
        }
    });
    $(".faq-product .faq-btn").on("click", function (e) {
        e.preventDefault();
        $(".faq-hidden-content").slideToggle();
    });


    // Triggered every time the add-to-cart modal is opened
    $(document).on('show.bs.modal', '#blockcart-modal', function () {
        var visibleModals = $('.modal:visible').length;

        // If no other mnodal open -> remove all backdrops
        if (visibleModals === 0) {
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
        } else {
            // if one modalmopen -> leave the first backdrop and remove the rest
            $('.modal-backdrop').not(':first').remove();
        }
    });

});

// toggle manufacturer desc text
document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('toggle-button')) {
        const toggleButton = document.getElementById('toggle-button');
        const textContainer = document.getElementById('toggle-content');

        toggleButton.addEventListener('click', function () {
            textContainer.classList.toggle('expanded');
            if (textContainer.classList.contains('expanded')) {
                toggleButton.innerText = 'Voir moins';
            } else {
                toggleButton.innerText = 'En savoir plus';
            }
        });
    }
});

// toggle expanded description categorie
document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.getElementById('descWrapper');
    const btn = document.getElementById('toggleDescription');

    if (wrapper && btn) {
        const wrapper_data = wrapper.getAttributeNames("short-desc");

        if (wrapper_data) {
            wrapper.classList.add('short');
        }

        // Traductions injectées depuis Smarty
        const expandText = btn.dataset.expandText;
        const collapseText = btn.dataset.collapseText;

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            wrapper.classList.toggle('expanded');
            btn.textContent = wrapper.classList.contains('expanded') ? collapseText : expandText;

            if (wrapper.classList.contains('expanded')) {
                wrapper.style.maxHeight = wrapperHeight + 'px';
            } else {
                wrapper.style.maxHeight = 72 + 'px';
            }
        });
    }
});